import React from 'react';
import { BrProps } from '@bloomreach/react-sdk';
import { default as BlogDetail } from '../BlogDetail/CMSWrapper';
import { default as CustomerStory } from '../CustomerStory/CMSWrapper';
import { default as PressRelease } from '../PressRelease/CMSWrapper';

export type ComponentMap = Record<string, React.ElementType>;

export type DocumentBackedPageContentProps = BrProps & {
  components?: ComponentMap;
};

/**
 * Map of content type to component.
 */
const COMPONENTS: ComponentMap = {
  'genetecweb:blogdetail': BlogDetail,
  'genetecweb:customerstory': CustomerStory,
  'genetecweb:pressrelease': PressRelease,
};

/**
 * Component that renders the appropriate component based on the content type.
 *
 */
export const DocumentBackedPageContent = ({
  components = COMPONENTS,
  ...brProps
}: DocumentBackedPageContentProps) => {
  const { document: documentRef } = brProps.component?.getModels() ?? {};
  const content = brProps.page?.getContent(documentRef);
  const { contentType } = content?.getData<{ contentType: keyof typeof components }>() ?? {
    contentType: null,
  };

  const Component = contentType ? components[contentType] : () => null;

  return <Component {...brProps} />;
};

export default React.memo(
  DocumentBackedPageContent,
  (prevProps: BrProps, nextProps: BrProps) => prevProps.page?.getUrl() === nextProps.page?.getUrl(),
);
